module.exports = __webpack_public_path__ + "img/brainfit_banner_2.5fc0c87c.jpg";